/** Все строки интерфейса. Узбекский — V1, ключи те же. */
export const ru = {
  app: { title: 'Debt Bot' },
  notInTelegram: {
    title: 'Откройте через Telegram',
    body: 'Это приложение работает внутри Telegram. Откройте бота и нажмите «Открыть приложение».',
    openBot: 'Открыть бота',
  },
  botMoved: {
    title: 'Бот переехал',
    body: (bot: string) => `Теперь это @${bot}. Все ваши долги и друзья уже там.`,
    open: 'Открыть нового бота',
  },
  home: {
    title: 'Долги',
    owedToMe: 'Мне должны',
    iOwe: 'Я должен',
    invite: 'Пригласить',
    add: 'Добавить',
    emptyTitle: 'Пригласите первого друга',
    emptyBody: 'Отправьте ему ссылку — после принятия вы будете видеть общий баланс.',
    disputed: (n: number) => (n === 1 ? '1 спорная' : `${n} спорных`),
    disputedAmount: 'Спорных',
    deletedUser: 'Удалённый пользователь',
    shareText:
      'Давай вести наши расчёты в Kvits, чтобы не путаться, кто кому сколько. Открой — и увидишь запись.',
    inviteLimit: 'Слишком много неотправленных приглашений. Отправь уже созданные или подожди.',
    /** Текст шаринга с черновиком. Ссылка идёт отдельно, первой строкой — см. lib/invite-share.ts. */
    shareDraftIPaid: (sum: string, note: string | null) =>
      `Я записал в Kvits: ты → мне ${sum}${note ? `, ${note}` : ''}. Открой и подтверди, чтобы было видно обоим.`,
    shareDraftPeerPaid: (sum: string, note: string | null) =>
      `Я записал в Kvits: я → тебе ${sum}${note ? `, ${note}` : ''}. Открой — будет видно обоим.`,
    draftTitle: 'Первая запись',
    draftWhoPaid: 'Кто платил?',
    draftMe: 'Я',
    draftPeer: 'Он',
    draftSend: 'Отправить',
    draftSkip: 'Пропустить',
    linkTitle: 'Ссылка-приглашение',
    copy: 'Скопировать',
    copied: 'Скопировано',
    copyFailed: 'Не удалось скопировать — выделите ссылку вручную.',
    settings: 'Настройки',
    search: 'Поиск по имени',
    nothingFound: 'Никого не найдено',
  },
  /** Главная нового пользователя: 0 связей (экран первого шага) или только отправленные ссылки. */
  onboarding: {
    title: 'С кем у тебя сейчас есть незакрытый долг?',
    body: 'Запиши — и отправь ему. Запись увидите только вы двое.',
    cta: 'Записать и отправить',
    skip: 'Пока просто посмотреть',
    pendingTitle: 'Ожидают',
    pendingLink: (date: string) => `ссылка от ${date}`,
    resend: 'Отправить ещё раз',
    /** Ссылка не сохранилась на устройстве — создаём новую, старая остаётся действительной. */
    newLink: 'Создать новую ссылку',
    newLinkHint: 'Прежняя ссылка не отзывается и продолжит работать.',
    inviteAnother: 'Пригласить другого',
  },
  pick: { title: 'Кому добавить?', empty: 'Сначала пригласите друга.' },
  person: {
    owesYou: (name: string) => `${name} должен тебе`,
    youOwe: (name: string) => `Ты должен ${name}`,
    settled: 'Вы в расчёте',
    quickAdd: 'Быстро добавить',
    add: 'Добавить',
    settle: 'Погасить',
    emptyFeed: 'Операций пока нет. Добавьте первую.',
    loadMore: 'Показать ещё',
    added: 'Добавлено',
    undo: 'Отменить',
    peerDeleted: 'Этот пользователь удалил аккаунт. Новые операции недоступны.',
  },
  form: {
    newTitle: 'Новая операция',
    editTitle: 'Изменить операцию',
    iPaid: 'Я заплатил',
    peerPaid: (name: string) => `${name} заплатил`,
    note: 'Заметка (необязательно)',
    add: (sum: string) => `Добавить · ${sum}`,
    addEmpty: 'Добавить',
    save: 'Сохранить',
    bigAmount: 'Проверьте сумму — больше 100 млн',
    maxAmount: 'Слишком большая сумма',
  },
  settle: {
    title: 'Погасить долг',
    full: (sum: string) => `Полностью · ${sum}`,
    other: 'Другая сумма',
    confirm: (sum: string) => `Погасить ${sum}`,
    direction: (payer: string, receiver: string) => `Кто вернул: ${payer} → ${receiver}`,
    me: 'я',
    toMe: 'мне',
    changed: (sum: string) => `Баланс изменился: теперь ${sum}. Нажмите ещё раз.`,
    overpay: (sum: string) => `Это больше долга — баланс станет ${sum} в обратную сторону`,
  },
  tx: {
    title: 'Операция',
    disputed: 'оспорено',
    edited: 'изменено',
    deleted: 'Операция удалена',
    paidFor: (payer: string, beneficiary: string) => `${payer} заплатил за ${beneficiary}`,
    returned: (payer: string, receiver: string) => `${payer} вернул ${receiver}`,
    addedBy: (name: string) => `добавил ${name}`,
    history: 'История',
    edit: 'Изменить',
    delete: 'Удалить',
    dispute: 'Оспорить',
    withdraw: 'Снять спор',
    confirmDelete: 'Удалить операцию? Вторая сторона получит уведомление.',
    disputeTitle: 'Оспорить операцию',
    disputeHint: 'Сумма исключится из баланса, пока вы не договоритесь. Автор получит уведомление.',
    disputeReason: 'Комментарий (необязательно)',
    disputeReasonBy: (name: string) => `${name}: `,
    events: {
      CREATED: 'Создано',
      UPDATED: 'Изменено',
      DELETED: 'Удалено',
      DISPUTED: 'Оспорено',
      DISPUTE_WITHDRAWN: 'Спор снят',
    } as Record<string, string>,
    fields: {
      amount: 'Сумма',
      payer_id: 'Кто заплатил',
      category: 'Категория',
      note: 'Заметка',
      dispute_cleared: 'Спор снят после правки',
    } as Record<string, string>,
  },
  invite: {
    offer: (name: string) => `${name} приглашает вести расчёты вместе`,
    body: 'Записи видите только вы двое.',
    recorded: (name: string) => `${name} записал`,
    youToName: (name: string) => `Ты → ${name}`,
    nameToYou: (name: string) => `${name} → ты`,
    accept: 'Принять',
    decline: 'Отклонить',
    self: 'Это ваша ссылка — отправьте её другу.',
    expired: 'Ссылка устарела.',
    used: 'Ссылка уже использована.',
    notFound: 'Ссылка не найдена.',
    alreadyConnected: (name: string) => `Вы уже связаны с ${name}.`,
    open: 'Открыть',
    inviterGone: 'Автор приглашения удалил аккаунт.',
  },
  settings: {
    title: 'Настройки',
    languageAuto: 'Как в Telegram',
    languageRu: 'Русский',
    languageUz: 'Ўзбекча',
    notifications: 'Уведомления о новых и изменённых операциях',
    notificationsHint: 'Об удалении, спорах и принятых приглашениях сообщаем всегда.',
    language: 'Язык',
    version: 'Версия',
    deleteAccount: 'Удалить аккаунт',
    deleteHint: 'Удаление делается в боте: откройте его и отправьте /settings.',
    openBot: 'Открыть бота',
    feedback: 'Предложить улучшение',
    feedbackHint: 'Идеи, что неудобно, чего не хватает',
  },
  feedback: {
    title: 'Предложить улучшение',
    body: 'Расскажите, что добавить или исправить. Сообщение придёт разработчику в Telegram.',
    placeholder: 'Ваше предложение',
    send: 'Отправить',
    sent: 'Спасибо! Предложение отправлено',
    tooOften: 'Слишком много сообщений. Попробуйте через час.',
  },
  errors: {
    network: 'Нет связи. Проверьте интернет и попробуйте ещё раз.',
    generic: 'Что-то пошло не так.',
    retry: 'Повторить',
    conflict: 'Операция была изменена. Данные обновлены — проверьте и повторите.',
  },
  common: {
    loading: 'Загрузка…',
    on: 'Вкл',
    off: 'Выкл',
    back: 'Назад',
    home: 'На главную',
    cancel: 'Отмена',
  },
  date: {
    today: 'сегодня',
    yesterday: 'вчера',
    months: ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
  },
  txKind: { settlement: 'Возврат', expense: 'Расход' },
};

export type Dictionary = typeof ru;
